"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectRewardTxb = collectRewardTxb;
exports.claimRewardsTxb = claimRewardsTxb;
exports.pendingRewardAmount = pendingRewardAmount;
const decimal_js_1 = require("decimal.js");
const index_js_1 = require("../index.js");
const transactions_1 = require("@mysten/sui/transactions");
const maps_js_1 = require("../common/maps.js");
const bcs_1 = require("@mysten/bcs");
async function collectRewardTxb(poolName, ignoreCache, tx) {
    let txb;
    if (tx) {
        txb = tx;
    }
    else {
        txb = new transactions_1.Transaction();
    }
    const bluefinPool = (await (0, index_js_1.getParentPool)(poolName, ignoreCache));
    const pool = index_js_1.poolInfo[poolName];
    const coin1 = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coin2 = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
    if (maps_js_1.AUTOBALANCE_SUI_FIRST_POOLS.includes(poolName)) {
        for (const reward of bluefinPool.content.fields.reward_infos) {
            const rewardType = "0x" + reward.fields.reward_coin_type;
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::collect_reward`,
                typeArguments: [
                    index_js_1.coinsList[coin1].type,
                    index_js_1.coinsList[coin2].type,
                    rewardType,
                ],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else if (maps_js_1.AUTOBALANCE_SUI_SECOND_POOLS.includes(poolName)) {
        for (const reward of bluefinPool.content.fields.reward_infos) {
            const rewardType = "0x" + reward.fields.reward_coin_type;
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_sui_second_pool::collect_reward`,
                typeArguments: [
                    index_js_1.coinsList[coin1].type,
                    index_js_1.coinsList[coin2].type,
                    rewardType,
                ],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else if (index_js_1.AUTOBALANCE_TYPE_1_POOLS.includes(poolName)) {
        for (const reward of bluefinPool.content.fields.reward_infos) {
            const rewardType = "0x" + reward.fields.reward_coin_type;
            txb.moveCall({
                target: `${pool.packageId}::alphafi_bluefin_type_1_pool::collect_reward`,
                typeArguments: [
                    index_js_1.coinsList[coin1].type,
                    index_js_1.coinsList[coin2].type,
                    rewardType,
                ],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(pool.poolId),
                    txb.object(pool.investorId),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(pool.parentPoolId),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    return txb;
}
async function claimRewardsTxb(userAddress, poolName) {
    const { getReceipts } = await Promise.resolve().then(() => __importStar(require("../index.js")));
    try {
        const receipts = await getReceipts(poolName, userAddress, true);
        const txb = await collectRewardTxb(poolName, true); //false for now
        const bluefinPool = (await (0, index_js_1.getParentPool)(poolName, false));
        const pool = index_js_1.poolInfo[poolName];
        const coin1 = index_js_1.doubleAssetPoolCoinMap[poolName].coin1;
        const coin2 = index_js_1.doubleAssetPoolCoinMap[poolName].coin2;
        const rewards = [];
        const rewardsList = bluefinPool.content.fields.reward_infos.map((ele) => {
            return "0x" + ele.fields.reward_coin_type;
        });
        rewardsList.push(index_js_1.coinsList[coin1].type.substring(2));
        rewardsList.push(index_js_1.coinsList[coin2].type.substring(2));
        console.log(rewardsList);
        if (maps_js_1.AUTOBALANCE_SUI_FIRST_POOLS.includes(poolName)) {
            for (const rewardType of [...new Set(rewardsList)]) {
                const balance = txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_sui_first_pool::get_user_rewards_v4`,
                    typeArguments: [
                        index_js_1.coinsList[coin1].type,
                        index_js_1.coinsList[coin2].type,
                        rewardType,
                    ],
                    arguments: [
                        txb.object(receipts[0].objectId),
                        txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(pool.parentPoolId),
                        txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                const coin = txb.moveCall({
                    target: "0x2::coin::from_balance",
                    typeArguments: [rewardType],
                    arguments: [balance],
                });
                rewards.push(coin);
            }
        }
        else if (maps_js_1.AUTOBALANCE_SUI_SECOND_POOLS.includes(poolName)) {
            for (const rewardType of [...new Set(rewardsList)]) {
                const balance = txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_sui_second_pool::get_user_rewards_v3`,
                    typeArguments: [
                        index_js_1.coinsList[coin1].type,
                        index_js_1.coinsList[coin2].type,
                        rewardType,
                    ],
                    arguments: [
                        txb.object(receipts[0].objectId),
                        txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(pool.parentPoolId),
                        txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                const coin = txb.moveCall({
                    target: "0x2::coin::from_balance",
                    typeArguments: [rewardType],
                    arguments: [balance],
                });
                rewards.push(coin);
            }
        }
        else if (index_js_1.AUTOBALANCE_TYPE_1_POOLS.includes(poolName)) {
            for (const rewardType of [...new Set(rewardsList)]) {
                const balance = txb.moveCall({
                    target: `${pool.packageId}::alphafi_bluefin_type_1_pool::get_user_rewards_v3`,
                    typeArguments: [
                        index_js_1.coinsList[coin1].type,
                        index_js_1.coinsList[coin2].type,
                        rewardType,
                    ],
                    arguments: [
                        txb.object(receipts[0].objectId),
                        txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                        txb.object(pool.poolId),
                        txb.object(pool.investorId),
                        txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                        txb.object(pool.parentPoolId),
                        txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                const coin = txb.moveCall({
                    target: "0x2::coin::from_balance",
                    typeArguments: [rewardType],
                    arguments: [balance],
                });
                rewards.push(coin);
            }
        }
        return { txb: txb, coinOut: rewards };
    }
    catch (e) {
        console.error("error in claim blue rewards", e);
    }
}
// TypeName struct from stdlib
const TypeName = bcs_1.bcs.struct("0x1::type_name::TypeName", {
    name: bcs_1.bcs.vector(bcs_1.bcs.u8()),
});
// VecMapEntry<K, V>
function VecMapEntry(KType, VType) {
    return bcs_1.bcs.struct(`Entry<${KType.name},${VType.name}>`, {
        key: KType,
        value: VType,
    });
}
// VecMap<K, V> (contents: vector<Entry<K, V>>)
function VecMap(KType, VType) {
    return bcs_1.bcs.struct(`VecMap<${KType.name},${VType.name}>`, {
        contents: bcs_1.bcs.vector(VecMapEntry(KType, VType)),
    });
}
// Specialization for TypeName → u256
const VecMap_TypeName_U256 = VecMap(TypeName, bcs_1.bcs.u256());
function parseReturnValue(rv) {
    let [rawBytes, typeTag] = rv;
    let bytes;
    if (typeof rawBytes === "string") {
        bytes = (0, bcs_1.fromBase64)(rawBytes);
    }
    else if (Array.isArray(rawBytes)) {
        bytes = Uint8Array.from(rawBytes);
    }
    else {
        bytes = rawBytes;
    }
    if (typeTag === "0x2::vec_map::VecMap<0x1::type_name::TypeName, u256>") {
        const parsed = VecMap_TypeName_U256.parse(bytes);
        // parsed.contents is an array of { key: { name: Uint8Array }, value: string }
        return parsed.contents.map((entry) => {
            // Ensure we normalize to Uint8Array
            const keyBytes = entry.key.name instanceof Uint8Array
                ? entry.key.name
                : Uint8Array.from(entry.key.name);
            const keyStr = new TextDecoder().decode(keyBytes);
            const valStr = entry.value.toString(); // u256 → string
            return { key: keyStr, value: valStr };
        });
    }
    return undefined; // fallback
}
async function pendingRewardAmount(userAddress, poolName) {
    const { getReceipts } = await Promise.resolve().then(() => __importStar(require("../index.js")));
    try {
        const txb = new transactions_1.Transaction();
        let poolInf = index_js_1.poolInfo[poolName];
        let coin1Type = index_js_1.coinsList[index_js_1.doubleAssetPoolCoinMap[poolName].coin1].type;
        let coin2Type = index_js_1.coinsList[index_js_1.doubleAssetPoolCoinMap[poolName].coin2].type;
        await collectRewardTxb(poolName, true, txb);
        if (maps_js_1.AUTOBALANCE_SUI_FIRST_POOLS.includes(poolName)) {
            txb.moveCall({
                target: `${poolInf.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v4`,
                typeArguments: [coin1Type, coin2Type],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolInf.poolId),
                    txb.object(poolInf.investorId),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolInf.parentPoolId),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${(0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_LATEST_PACKAGE_ID}::alphafi_bluefin_sui_first_pool::get_cur_acc_per_xtoken`,
                typeArguments: [coin1Type, coin2Type],
                arguments: [txb.object(index_js_1.poolInfo[poolName].poolId)],
            });
        }
        else if (maps_js_1.AUTOBALANCE_SUI_SECOND_POOLS.includes(poolName)) {
            txb.moveCall({
                target: `${poolInf.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v3`,
                typeArguments: [coin1Type, coin2Type],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolInf.poolId),
                    txb.object(poolInf.investorId),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolInf.parentPoolId),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${(0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_LATEST_PACKAGE_ID}::alphafi_bluefin_sui_second_pool::get_cur_acc_per_xtoken`,
                typeArguments: [coin1Type, coin2Type],
                arguments: [txb.object(index_js_1.poolInfo[poolName].poolId)],
            });
        }
        else {
            txb.moveCall({
                target: `${poolInf.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [coin1Type, coin2Type],
                arguments: [
                    txb.object((0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolInf.poolId),
                    txb.object(poolInf.investorId),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, index_js_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolInf.parentPoolId),
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${(0, index_js_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_LATEST_PACKAGE_ID}::alphafi_bluefin_type_1_pool::get_cur_acc_per_xtoken`,
                typeArguments: [coin1Type, coin2Type],
                arguments: [txb.object(index_js_1.poolInfo[poolName].poolId)],
            });
        }
        let res = await (0, index_js_1.getSuiClient)().devInspectTransactionBlock({
            sender: userAddress,
            transactionBlock: txb,
        });
        const receipts = await getReceipts(poolName, userAddress, true);
        const receipt = receipts[0];
        const userXtokenBalance = receipt.content.fields.xTokenBalance;
        const totalPendingRewardAmounts = {};
        const userPendingReward = {};
        const curAcc = {};
        const lastAcc = {};
        const userPendingRewardsAll = receipt.content.fields.pending_rewards.fields.contents;
        for (let i = 0; i < userPendingRewardsAll.length; i++) {
            userPendingReward["0x" + userPendingRewardsAll[i].fields.key.fields.name] = userPendingRewardsAll[i].fields.value;
        }
        const currAccForAllRewards = parseReturnValue(res.results[res.results.length - 1].returnValues[0]);
        currAccForAllRewards?.forEach((reward) => {
            curAcc["0x" + reward.key] = reward.value;
        });
        const lastAccAll = receipt.content.fields.last_acc_reward_per_xtoken.fields.contents;
        lastAccAll.forEach((reward) => {
            lastAcc["0x" + reward.fields.key.fields.name] = reward.fields.value;
        });
        const coinTypeToCoin = maps_js_1.coinTypeMap;
        Object.keys(curAcc).forEach((type) => {
            if (!coinTypeToCoin[type]) {
                console.error("coin not present", type);
                return;
            }
            const cur = new decimal_js_1.Decimal(curAcc[type]);
            const last = new decimal_js_1.Decimal(type in lastAcc ? lastAcc[type] : "0");
            const pending = new decimal_js_1.Decimal(type in userPendingReward ? userPendingReward[type] : "0");
            const totalPending = cur
                .minus(last)
                .mul(userXtokenBalance)
                .div(1e36)
                .plus(pending)
                .div(Math.pow(10, index_js_1.coinsList[coinTypeToCoin[type]].expo))
                .toString();
            totalPendingRewardAmounts[type] = totalPending.toString();
        });
        return totalPendingRewardAmounts;
    }
    catch (e) {
        console.error("error in calculate pending blue rewards", e);
        return {};
    }
}
//# sourceMappingURL=blueRewards.js.map